import { z } from "zod";

export const certificateSchema = z.object({
  company_id: z.number(),
  company_name: z.string().nullish(),
  issued_at: z.coerce.date(),
  registration_number: z.string().nullable(),
  company_address: z.string().nullish(),
  score: z.number(),
});

export type Certificate = z.infer<typeof certificateSchema>;
